<main class="card p-4">
  <div class="container-body">
    <div class="container-table-header d-flex align-items-center justify-content-between gap-2 flex-wrap">
      <p class="h4">ENTRADAS REALIZADAS</p>
      <div class="d-flex align-items-center gap-2 flex-wrap">
        <div class="input-search">
          <i class="pi pi-search"></i>
          <input
            type="text"
            class="form-control table-controls__search"
            placeholder="Buscar..."
            [(ngModel)]="searchTerm"
            (input)="filterCheckIns()" />
        </div>
      </div>
    </div>

    <div class="table-container mt-3">
      <p-table [value]="paginatedCheckIns" [scrollable]="true" class="table" class="p-datatable-striped">
        <ng-template pTemplate="header">
          <tr>
            <th>#</th>
            <th>NOME DO PARTICIPANTE</th>
            <th>CPF</th>
            <th>EMAIL</th>
            <th>STATUS</th>
            <th>DATA DO CHECK-IN</th>
            <th>RESPONSÁVEL</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-checkIn>
          <tr>
            <td>{{ checkIn.id }}</td>
            <td>{{ checkIn.user_name }} {{ checkIn.user_last_name }}</td>
            <td>{{ maskCpf(checkIn.user_cpf) }}</td>
            <td>{{ maskEmail(checkIn.user_email) }}</td>
            <td>
              <p class="status" [ngClass]="getScanStatusColor(checkIn.status)">{{ getScanStatus(checkIn.status) }}</p>
            </td>
            <td>{{ checkIn.scanned_at | date: "dd/MM/yyyy HH:mm" }}</td>
            <td>{{ checkIn.scanned_by }}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="7" style="text-align: center">Nenhum dado a ser mostrado</td>
          </tr>
        </ng-template>
      </p-table>

      <p-paginator
        (onPageChange)="onPageChange($event)"
        [first]="(currentPage - 1) * itemsPerPage"
        [rows]="itemsPerPage"
        [totalRecords]="filteredCheckIns.length || 0"
        [showCurrentPageReport]="false"
        [showPageLinks]="true"
        [showJumpToPageDropdown]="false"
        [rowsPerPageOptions]="itemsPerPageOptions"
        currentPageReportTemplate="Mostrando {first} até {last} de {totalRecords}" />
    </div>
  </div>
</main>
